import {useEffect, useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../selectors/modals/addcash';
import {updateBalance, addCash} from '../../reducers/games/actions';
import {setPreset} from '../../reducers/wallet/actions';
import Numeric from '../components/numeric';
import BlueButton from '../components/blue-button';
import {NumericFormat} from 'react-number-format';
import ModalsLib from '../../lib/modals';
import {getCashoutsRange} from '../../utils/sessions';
import tippy from 'tippy.js';
import Tooltip from '../../utils/tooltips';
import {toast} from 'react-toastify';

export default () => {
    const {user, game, login, data, buttons, sessions} = useSelector(Selector);

    const getMinimalDeposit = (wager="LOW") => {
        if(wager === "LOW") return 10;
        if(wager === "MEDIUM") return 15;
        if(wager === "HIGH") return 20;
        return 10;
    }

    const dispatch = useDispatch(),
          inputRef = useRef(),
          [state, setState] = useState({
            amount: getMinimalDeposit(user.roi_rate || "LOW"),
            minimal_deposit: getMinimalDeposit(user.roi_rate || "LOW")
          });

    const cashout_range = getCashoutsRange({type: 'cash', amount: state.amount, loginBalance: login.balance, sessions, roi_rate: user.roi_rate});

    const modalCloseHandler = () => {
        console.log(`MODAL CLOSE`);
    }

    const setAmount = amount => {
        setState({
            ...state,
            amount
        });
    }

    useEffect(() => {
        tippy('#cashoutRulesInfo', {
            placement: "top",
            animation: 'fade',
            theme: 'translucent',
            arrow: true, 
            content: Tooltip.sessions(sessions, user.roi_rate),
            allowHTML: true
        });

        document.addEventListener('modal.close', modalCloseHandler);
        return () => document.removeEventListener('modal.close', modalCloseHandler);
    }, []);

    if(!login || login.status === 0)
        return <></>;

    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster">
            <div className="modal-header">
                <div className="title">Add Cash</div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="game">
                    <div className="image" style={{backgroundImage: `url(${window.location.origin}/source/system/games/${game.slug}.png)`}}></div>
                    <div className="details">
                        <div className="top">
                            <div className="name">{game.name}</div>
                            <div className="change" onClick={e => {
                                ModalsLib.open('changeGame', {
                                    handler: e => ModalsLib.open('addcash', {game: e})
                                });
                            }}>change</div>
                        </div>
                        <div className="bottom">
                            <div className="detail">
                                <div className="title">Login</div>
                                <div className="value">{login.login}</div>
                            </div>

                            <div className="balance">
                                <div className="detail">
                                    <div className="title">Balance</div>
                                    <div className="value">
                                        <Numeric value={login.balance} />
                                    </div>
                                </div>

                                <svg className={`${login.balance_details.need_update ? 'updating' : 'noupdating'}`} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"  onClick={e => {
                                    if(buttons.update)
                                        return;

                                    if(login.balance_details.need_update) {
                                        toast.dismiss();
                                        toast.info(`Your balance is already being updated...`);
                                        return;
                                    }

                                    dispatch(updateBalance(login.game));
                                }}>
                                    <path d="M18.3337 9.99996C18.3337 14.6 14.6003 18.3333 10.0003 18.3333C5.40033 18.3333 2.59199 13.7 2.59199 13.7M2.59199 13.7H6.35866M2.59199 13.7V17.8666M1.66699 9.99996C1.66699 5.39996 5.36699 1.66663 10.0003 1.66663C15.5587 1.66663 18.3337 6.29996 18.3337 6.29996M18.3337 6.29996V2.13329M18.3337 6.29996H14.6337" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {login.balance < 2 ? (
                    <>
                        <div className="amount-block">
                            <div className="label">Amount</div>
                            <div className="input-block">
                                <div className="input">
                                    <div className="edit">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z" stroke="#4FACFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.8933 6.88916C12.3233 9.64916 14.5633 11.7592 17.3433 12.0392" stroke="#4FACFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <NumericFormat  
                                        displayType='input'
                                        type='tel'
                                        value={state.amount === 0 ? '' : state.amount}
                                        placeholder='$0.00'
                                        prefix={'$'} 
                                        decimalSeparator="." 
                                        decimalScale={0} 
                                        thousandSeparator=" "
                                        maxLength={8}
                                        getInputRef={inputRef}
                                        onValueChange={(values) => {
                                            setState({
                                                ...state,
                                                amount: values.floatValue
                                            })
                                        }} />

                                    <div className="clear" onClick={e => setAmount(0)}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>

                                {/* <div className="input-lore">
                                    Min Deposit $10
                                    
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM6.33975 3.339C6.38432 3.38362 6.41966 3.43657 6.44376 3.49485C6.46786 3.55313 6.48025 3.61558 6.48021 3.67864C6.48018 3.7417 6.46772 3.80414 6.44356 3.86239C6.41939 3.92064 6.38399 3.97356 6.33938 4.01813C6.29476 4.06269 6.2418 4.09804 6.18352 4.12214C6.12525 4.14624 6.0628 4.15862 5.99973 4.15859C5.93667 4.15855 5.87423 4.1461 5.81599 4.12193C5.75774 4.09777 5.70482 4.06237 5.66025 4.01775C5.57024 3.92764 5.51972 3.80547 5.51979 3.67811C5.51986 3.55075 5.57052 3.42863 5.66062 3.33862C5.75073 3.24862 5.8729 3.19809 6.00027 3.19816C6.12763 3.19823 6.24974 3.24889 6.33975 3.339ZM6.48 8.32125C6.48 8.44855 6.42943 8.57064 6.33941 8.66066C6.24939 8.75068 6.1273 8.80125 6 8.80125C5.8727 8.80125 5.75061 8.75068 5.66059 8.66066C5.57057 8.57064 5.52 8.44855 5.52 8.32125V5.56575C5.52 5.43845 5.57057 5.31636 5.66059 5.22634C5.75061 5.13632 5.8727 5.08575 6 5.08575C6.1273 5.08575 6.24939 5.13632 6.33941 5.22634C6.42943 5.31636 6.48 5.43845 6.48 5.56575V8.32125Z" fill="#4F546A"/>
                                    </svg>
                                </div> */}
                            </div> 

                            <div className="buttons">
                                <div className="amounts">
                                    <div className={`amount active`} onClick={e => setAmount((state.amount || 0) + 5)}>+5</div>
                                    <div className={`amount active`} onClick={e => setAmount((state.amount || 0) + 10)}>+10</div>
                                    <div className={`amount active`} onClick={e => setAmount((state.amount || 0) + 25)}>+25</div>
                                    <div className={`amount active`} onClick={e => setAmount((state.amount || 0) * 2)}>X2</div>
                                    <div className={`amount clear`} onClick={e => setAmount('')}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5 4.98356C14.725 4.70856 11.9333 4.56689 9.15 4.56689C7.5 4.56689 5.85 4.65023 4.2 4.81689L2.5 4.98356" stroke="#FE4F52" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.08331 4.1415L7.26665 3.04984C7.39998 2.25817 7.49998 1.6665 8.90831 1.6665H11.0916C12.5 1.6665 12.6083 2.2915 12.7333 3.05817L12.9166 4.1415" stroke="#FE4F52" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15.7084 7.6167L15.1667 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32502C5.00002 18.3334 4.92502 17.3167 4.83335 16.0084L4.29169 7.6167" stroke="#FE4F52" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>

                                {(state.amount >= state.minimal_deposit) ? (
                                    <div className="cashouts" id="cashoutRulesInfo" style={{marginTop: "10px"}}>
                                        <div className="rules">
                                            Cashouts range
                                        </div>
                                        <div className="value">
                                            <span>{cashout_range.text}</span>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-tip data-for="cashoutRules">
                                                <rect width="20" height="20" rx="10" fill="#30344F"/>
                                                <path d="M11.7697 12.8984C11.5994 12.9584 11.0599 13.1013 10.8139 12.9741C10.7799 12.9562 10.7513 12.9312 10.7304 12.9011C10.7095 12.8709 10.697 12.8367 10.694 12.8012C10.6167 12.3554 10.9842 11.3252 11.183 10.7723C11.2492 10.588 11.2965 10.4537 11.3154 10.3722C11.459 9.77067 11.388 9.31059 11.1041 9.00482C10.7624 8.6369 10.1564 8.56532 9.65928 8.6319C9.15374 8.69294 8.65972 8.81599 8.19081 8.99768C8.16903 9.00723 8.14999 9.02124 8.13521 9.0386C8.12043 9.05595 8.1103 9.07619 8.10563 9.0977L8.00311 9.54206C7.99756 9.56705 7.99946 9.59293 8.00861 9.61704C8.01776 9.64114 8.03382 9.66261 8.05516 9.67923C8.07676 9.69549 8.10264 9.7064 8.13028 9.71091C8.15793 9.71542 8.18638 9.71336 8.21289 9.70495C8.40059 9.64208 8.98735 9.50063 9.19713 9.67494C9.31543 9.77353 9.2823 9.98214 9.23498 10.1379C9.18609 10.3008 9.12773 10.4765 9.06779 10.6608C8.67977 11.8568 8.23813 13.2127 8.93845 13.6356C9.26979 13.8648 9.67309 13.9924 10.0899 14C10.5 14 11.0063 13.8828 11.735 13.6156C11.757 13.6079 11.7767 13.5958 11.7928 13.5802C11.8089 13.5646 11.821 13.546 11.8281 13.5256L11.9779 13.0727C11.9864 13.0469 11.9868 13.0194 11.979 12.9934C11.9712 12.9674 11.9555 12.9439 11.9338 12.9255C11.912 12.9075 11.8851 12.8954 11.856 12.8906C11.827 12.8858 11.7971 12.8885 11.7697 12.8984ZM10.858 6C10.6324 6.00014 10.4119 6.06087 10.2243 6.17452C10.0368 6.28816 9.89063 6.44962 9.80436 6.63848C9.71808 6.82735 9.69555 7.03514 9.7396 7.23561C9.78366 7.43607 9.89233 7.6202 10.0519 7.76473C10.2114 7.90926 10.4147 8.0077 10.636 8.04761C10.8573 8.08752 11.0867 8.06711 11.2952 7.98896C11.5037 7.9108 11.6819 7.77842 11.8073 7.60853C11.9328 7.43863 11.9998 7.23887 12 7.03447C11.9999 6.76014 11.8796 6.49706 11.6654 6.30307C11.4513 6.10909 11.1609 6.00008 10.858 6Z" fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                ) : <></>}
                            </div>
                        </div>

                        {(state.amount < state.minimal_deposit) ? (
                            <div className="modal-message warning">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>Minimal deposit on game in <b>{user.roi_rate}</b> wagering mode is <b>${state.minimal_deposit}</b></span>
                            </div>
                        ) : (
                            <>
                                {state.amount > user.balance && (
                                    <div className="modal-message warning" onClick={e => {
                                        dispatch(setPreset({
                                            mode: 'tabs',
                                            tab: 'deposit'
                                        }));

                                        ModalsLib.open('wallet');
                                    }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <span><b>Not enough funds!</b> Click on this message to deposit <b><Numeric value={state.amount - user.balance} /></b></span>
                                    </div>
                                )}
                            </>
                        )}


                        {/* {state.amount < 15 ? (
                            <div className="modal-message warning" style={{alignItems: 'center'}} onClick={e => setState({
                                ...state,
                                amount: 15
                            })}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>The minimum deposit amount in the game is <b>$15</b></span>
                            </div>
                        ) : (
                            <>
                                {state.amount > user.balance && (
                                    <div className="modal-message warning" onClick={e => {
                                        ModalsLib.close();
                                        window.alert(`Открываем модалку кошелька с вкладкой депозит`)
                                    }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <span><b>Not enough funds!</b> Click on this message to deposit <b><Numeric value={state.amount - user.balance} /></b></span>
                                    </div>
                                )}
                            </>
                        )} */}
                    </>
                ) : (
                    <>
                        <div className="modal-message warning">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>You cannot make a deposit into this game because <b>your game balance is more than $2</b>.</span>
                        </div>

                        <div className="modal-message info">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10 12.5L11.5 14L14.75 11" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Lower your game balance below <b>$2</b> to make a deposit into this game. <b>If the balance is invalid, update it</b></span>
                        </div>
                    </>
                )}
            </div>

            <div className="modal-footer">
                {login.balance < 2 ? (
                    <BlueButton disabled={state.amount < 1} active={buttons.add} onClick={e => {
                        if(!buttons.add)
                            dispatch(addCash({
                                amount: state.amount,
                                game: login.game
                            }));
                    }}>
                        Add Cash
                    </BlueButton>
                ) : (
                    <BlueButton onClick={e => {
                        ModalsLib.open('changeGame', {
                            handler: e => ModalsLib.open('addcash', {game: e})
                        });
                    }}>
                        Change game
                    </BlueButton>
                )}
                <div className="button close" onClick={e => ModalsLib.close()}>
                    Close
                </div>
            </div>
        </div>
    )
}